module.exports = __webpack_public_path__ + "static/c2-a16b80ac71caf85ca85224b9f3dff666.png";